import MuiStack from '@mui/material/Stack'
import type { CSSProperties } from '@mui/material/styles'
import type { ComponentProps } from 'react'

export const Stack = ({
	col,
	center,
	full,
	justify,
	align,
	sx,
	...props
}: ComponentProps<typeof MuiStack> & {
	col?: boolean
	center?: boolean
	full?: boolean
	justify?: CSSProperties['justifyContent']
	align?: CSSProperties['alignItems']
}) => (
	<MuiStack
		direction={col ? 'column' : 'row'}
		sx={[
			{
				justify: justify ?? (center ? 'center' : undefined),
				align: align ?? (center ? 'center' : undefined),
				w: full ? '100%' : undefined,
				h: full ? '100%' : undefined,
			},
			...(Array.isArray(sx) ? sx : [sx]),
		]}
		{...props}
	/>
)
